import React, { createContext, useContext } from 'react';

/**
 * ConfigContext provides runtime tenant configuration to the entire app.
 *
 * - visualConfig: available pre-login (branding, theme URL, logo URL)
 * - bootstrap: available post-login (full tenant config from BFF)
 *
 * Usage:
 *   const { visualConfig, bootstrap } = useConfigContext();
 */
const ConfigContext = createContext({
  visualConfig: null,
  bootstrap: null,
});

export const ConfigContextProvider = ({ visualConfig, bootstrap, children }) => (
  <ConfigContext.Provider value={{ visualConfig, bootstrap }}>
    {children}
  </ConfigContext.Provider>
);

export const useConfigContext = () => useContext(ConfigContext);

export default ConfigContext;
